<script setup lang="ts">
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import { ShareFireOutbreakAlertEnum } from '../enums/ShareFireOutbreakAlert.enum'
import { computed } from 'vue'

const props = defineProps<{
	seen: boolean
}>()

const emit = defineEmits<{
	(event: 'change', value: ShareFireOutbreakAlertEnum): void
}>()

const options = [
	{
		name: 'Compartilhar no Whatsapp',
		icon: 'ic:baseline-whatsapp',
		event: ShareFireOutbreakAlertEnum.WHATSAPP,
	},
]

const iconColor = computed(() => (props.seen ? 'text-blue-base' : 'text-red-danger'))
</script>

<template>
	<context-menu
		:options="options"
		:icon-color="iconColor"
		@change="emit('change', $event)"
	/>
</template>
